import { z } from 'zod';
import { InvoiceSectionName } from '../../../enums/enum.js';
export const invoice = z.object({
    id: z.number(),
    createdOn: z.string(),
    toDate: z.string(),
    fromDate: z.string(),
    invoicePdfUrl: z.string().nullish(),
    totalAmount: z.number(),
    isMonthlyCrew: z.boolean(),
    ordersCsvUrl: z.string().nullish(),
    reordersCsvUrl: z.string().nullish(),
    refundsCsvUrl: z.string().nullish(),
    adjustmentsCsvUrl: z.string().nullish(),
    /** In USD, signed as the invoice applies them: credits such as refunds and revenue share are negative */
    sections: z.array(z.object({ name: z.enum(InvoiceSectionName), amount: z.number() })),
});
//# sourceMappingURL=invoices.js.map